import type { MeetingTemplateRow } from '@wundo/ui';
import type { MeetingTemplateItem } from '@wundo/shared/meetingTemplate.ts';

/**
 * A template from the API as the shared list draws it. The list is split by
 * kind, so the row says nothing about kind. Its track or cohort is named to
 * whoever may change it: a member only ever sees their own anyway.
 */
export function meetingTemplateRow(template: MeetingTemplateItem): MeetingTemplateRow {
  return {
    id: template.id,
    name: template.name,
    color: template.color,
    isDefault: template.is_default,
    personal: template.scope === 'personal',
    audience: template.editable
      ? (template.track?.title ?? template.cohort?.label)
      : undefined,
  };
}
